import http from "../HttpService";

const controller = "/pricelist/fe/";

function getUrl() {
  return `${controller}${http.GUID}`;
}

export function getData() {
  return http.get(getUrl());
}
